module.exports = __webpack_public_path__ + "static/media/Hen-180x180.2d76bd1a.png";